import Icon from '../components/Icon.vue'

Icon.register({
  'grin-wink': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M0 256C0 393 111 504 248 504S496 393 496 256 385 8 248 8 0 119 0 256zM200 208C200 225.7 185.7 240 168 240S136 225.7 136 208 150.3 176 168 176 200 190.3 200 208zM368 233L358.5 224.5C343.7 211.3 312.3 211.3 297.5 224.5L288 233C279.7 240.4 266.4 233.4 268.2 222.2 272.2 197 302.4 180.1 328.1 180.1S384 197 388 222.2C389.6 233.2 376.5 240.4 368 233zM124.9 320.8C155.1 330.5 200 336 248 336S340.9 330.5 371.1 320.8C382.4 317.1 393.7 326.8 391.8 338.7 382.6 393.7 308.6 432 248 432S113.5 393.7 104.2 338.7C102.2 326.8 113.5 317.1 124.9 320.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/grin-wink.js
// module id = /PKI
// module chunks = 144